import React, { useState } from "react";
import { TextField, Chip, Box, Typography, Button, Stack } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";

// Email validation helper
function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

const EmailChipsInput = ({ emails, setEmails, disabled }) => {
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState("");

  const handleAdd = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    if (!validateEmail(trimmed)) {
      setInputError("Invalid email address");
      return;
    }
    if (emails.includes(trimmed)) {
      setInputError("Duplicate email");
      return;
    }
    setEmails([...emails, trimmed]);
    setInputValue("");
    setInputError("");
  };

  const handleDelete = (toDelete) => {
    setEmails(emails.filter(email => email !== toDelete));
  };

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="h5" sx={{ mb: 1 }}>Send Report To (One or More Emails):</Typography>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", mb: 1 }}>
        {emails.map(email => (
          <Chip
            key={email}
            label={email}
            onDelete={() => handleDelete(email)}
            deleteIcon={<CancelIcon />}
            color="primary"
            sx={{ mb: 1 }}
          />
        ))}
      </Stack>
      <TextField
        type="email"
        value={inputValue}
        error={!!inputError}
        helperText={inputError || ""}
        placeholder="Enter email(s) and press 'Add Email' or 'Enter'"
        onChange={e => {
          setInputValue(e.target.value);
          setInputError("");
        }}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            handleAdd();
          }
        }}
        disabled={disabled}
        size="small"
        sx={{ width: "100%" }}
      />
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleAdd}
        disabled={!inputValue.trim() || disabled}
      >
        Add Email
      </Button>
    </Box>
  );
};

export default EmailChipsInput;
